import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import AbsenceCard from './absenceCard';

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gridGap: 12,
    width: '100%',
  },
}));

const AbsenceCards = ({
  translations,
  absences = [],
  getBreakdownData,
  canManageBalance,
  onManageBalancePreviousYear,
  onManageBalanceCurrentYear,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {absences.map(absence => {
        return (
          <div key={`abscence_${absence.absence}`}>
            <AbsenceCard
              translations={translations}
              absence={absence}
              canManageBalance={canManageBalance}
              getBreakdownData={getBreakdownData}
              onManageBalanceCurrentYear={onManageBalanceCurrentYear(absence)}
              onManageBalancePreviousYear={onManageBalancePreviousYear(absence)}
            />
          </div>
        );
      })}
    </div>
  );
};

AbsenceCards.propTypes = {
  translations: PropTypes.object.isRequired,
  absences: PropTypes.arrayOf(PropTypes.object),
  canManageBalance: PropTypes.bool.isRequired,
  getBreakdownData: PropTypes.func.isRequired,
  onManageBalanceCurrentYear: PropTypes.func.isRequired,
  onManageBalancePreviousYear: PropTypes.func.isRequired,
};

export default AbsenceCards;
